<div class="container p-4 md:p-8 bg-white rounded-lg shadow-lg space-y-6">
  <h1 class="text-2xl font-semibold">Cadastro de Vendedor</h1>

  <form #vendedorForm="ngForm" name="vendedorForm" class="space-y-4">
    <p-toast></p-toast>
    <p-confirmDialog></p-confirmDialog>

    <!-- Linha 1 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="nome" class="mb-1 font-medium text-gray-700">Nome</label>
        <input pInputText id="nome" type="text" placeholder="Nome" [(ngModel)]="vendedor.nome" name="nome" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="usuario" class="mb-1 font-medium text-gray-700">Selecione o usuário</label>
        <p-dropdown data-testid="usuario-dropdown" [options]="usuarios" optionLabel="username" optionValue="id" [(ngModel)]="selectedUsuarioId" name="usuario" placeholder="Selecione um usuário" class="w-full"></p-dropdown>
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="cpf" class="mb-1 font-medium text-gray-700">CPF</label>
        <input pInputText id="cpf" type="text" mask="000.000.000-00" placeholder="CPF" [(ngModel)]="vendedor.cpf" name="cpf" class="w-full p-component rounded border-gray-300" />
      </div>
    </div>

    <!-- Linha 2 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="celular" class="mb-1 font-medium text-gray-700">Celular</label>
        <input pInputText id="celular" type="text" mask="(00) 0 0000-0000" placeholder="Celular" [(ngModel)]="vendedor.celular" name="celular" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="telefone" class="mb-1 font-medium text-gray-700">Telefone</label>
        <input pInputText id="telefone" type="text" mask="(00) 0000-0000" placeholder="Telefone" [(ngModel)]="vendedor.telefone" name="telefone" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="rg" class="mb-1 font-medium text-gray-700">RG</label>
        <input pInputText id="rg" type="text" placeholder="RG" [(ngModel)]="vendedor.rgIE" name="rg" class="w-full p-component rounded border-gray-300" />
      </div>
    </div>

    <!-- Linha 3 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <label for="rua" class="mb-1 font-medium text-gray-700">Rua</label>
        <input pInputText id="rua" type="text" placeholder="Rua" [(ngModel)]="vendedor.endereco" name="rua" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="numero" class="mb-1 font-medium text-gray-700">Número</label>
        <input pInputText id="numero" type="text" placeholder="Número" [(ngModel)]="vendedor.numero" name="numero" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="bairro" class="mb-1 font-medium text-gray-700">Bairro</label>
        <input pInputText id="bairro" type="text" placeholder="Bairro" [(ngModel)]="vendedor.bairro" name="bairro" class="w-full p-component rounded border-gray-300" />
      </div>
    </div>

    <!-- Linha 4 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="cep" class="mb-1 font-medium text-gray-700">CEP</label>
        <input pInputText id="cep" type="text" placeholder="CEP" mask="00000-000" [(ngModel)]="vendedor.cep" name="cep" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-4 flex flex-col">
        <label for="cidade" class="mb-1 font-medium text-gray-700">Cidade</label>
        <input pInputText id="cidade" type="text" placeholder="Cidade" [(ngModel)]="vendedor.cidade" name="cidade" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-2 flex flex-col">
        <label for="estado" class="mb-1 font-medium text-gray-700">Estado</label>
        <input pInputText id="estado" type="text" placeholder="UF" [(ngModel)]="vendedor.estado" name="estado" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-3 flex flex-col">
        <label for="email" class="mb-1 font-medium text-gray-700">Email</label>
        <input pInputText id="email" type="text" placeholder="Email" [(ngModel)]="vendedor.email" name="email" class="w-full p-component rounded border-gray-300" />
      </div>
    </div>

    <!-- Linha 5 -->
    <div class="grid grid-cols-1 md:grid-cols-12 gap-4">
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <label for="contato" class="mb-1 font-medium text-gray-700">Contato</label>
        <input pInputText id="contato" type="text" placeholder="Contato" [(ngModel)]="vendedor.contato" name="contato" class="w-full p-component rounded border-gray-300" />
      </div>
      <div class="col-span-12 md:col-span-6 flex flex-col">
        <label for="sexo" class="mb-1 font-medium text-gray-700">Sexo</label>
        <select id="sexo" [(ngModel)]="vendedor.sexo" name="sexo" class="w-full h-12 p-component rounded border border-gray-300">
          <option value="" disabled selected>Selecione o Sexo</option>
          <option value="MASCULINO">Masculino</option>
          <option value="FEMININO">Feminino</option>
        </select>
      </div>
    </div>

    <div class="flex space-x-4 pt-4">
      <div class="button-group">
        <button *ngIf="!editMode" pButton type="button" class="btn btn-primary btn-md" (click)="cadastrar()">
          <i class="pi pi-check mr-2"></i>
          <span>Cadastrar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-primary btn-md" (click)="salvarAlteracao()">
          <i class="pi pi-save mr-2"></i>
          <span>Salvar</span>
        </button>
        <button *ngIf="editMode" pButton type="button" class="btn btn-secondary btn-md" (click)="cancelarEdicao()">
          <i class="pi pi-times mr-2"></i>
          <span>Cancelar</span>
        </button>
      </div>
    </div>
  </form>

  <div class="overflow-x-auto">
    <p-table [value]="vendedores" class="w-full mt-6">
      <ng-template pTemplate="header">
        <tr>
          <th class="p-2 border-b text-left">Id</th>
          <th class="p-2 border-b text-left">Nome</th>
          <th class="p-2 border-b text-left">Usuário</th>
          <th class="p-2 border-b text-left">Situação</th>
          <th class="p-2 border-b text-left">CPF</th>
          <th class="p-2 border-b text-left">Celular</th>
          <th class="p-2 border-b text-left">Data Cadastro</th>
          <th class="p-2 border-b text-left">Data Última Modificação</th>
          <th class="p-2 border-b text-left">Ações</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-vendedor>
        <tr>
          <td class="p-2 border-b">{{ vendedor.id }}</td>
          <td class="p-2 border-b">{{ vendedor.nome }}</td>
          <td class="p-2 border-b">{{ vendedor.usuario?.username || vendedor.usuarioId || '-' }}</td>
          <td class="p-2 border-b">
            <ng-container *ngIf="vendedor.ativo !== false; else notActive">
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-green-100 text-green-800">Ativo</span>
            </ng-container>
            <ng-template #notActive>
              <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-800">Desativado</span>
            </ng-template>
          </td>
          <td class="p-2 border-b">{{ vendedor.cpf | mask:'000.000.000-00' }}</td>
          <td class="p-2 border-b">{{ vendedor.celular }}</td>
          <td class="p-2 border-b">{{ vendedor.dataCadastro | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">{{ vendedor.dataUltimaModificacao | date : "dd/MM/yyyy HH:mm:ss" }}</td>
          <td class="p-2 border-b">
            <div class="flex items-center space-x-1">
              <button pButton type="button" class="p-button-text p-button-sm text-gray-700" title="Editar vendedor" (click)="editar(vendedor)">
                <i class="pi pi-pencil"></i>
              </button>
              <button pButton type="button" class="p-button-text p-button-sm" [ngClass]="vendedor.ativo ? 'text-red-600' : 'text-green-600'" [title]="vendedor.ativo ? 'Desativar vendedor' : 'Ativar vendedor'" (click)="confirmarAtivarDesativar(vendedor)">
                <i [ngClass]="vendedor.ativo ? 'pi pi-ban text-red-600' : 'pi pi-user-plus text-green-600'"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
